import React from 'react';
import { Helmet } from 'react-helmet-async';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { EntityList, PageHead } from '../../components/EntityList';
import ContractEditor from './ContractEditor';
import { useLabels } from '../../hooks/useLabels';

function EditContract() {
	const { t } = useLabels();
	const { id, accountId, assetId } = useParams();
	const navigate = useNavigate();
	const { pathname } = useLocation();

	// Precise per-route prefixes (see App.js), matching NewContract.jsx's
	// approach — contextual edits keep the tab's preload context so the
	// owner/property typeahead stays disabled and scoped.
	const preloadAccountId = pathname.startsWith('/AdminScreen/accounts/account/') ? accountId : null;
	const preloadAssetId = pathname.startsWith('/AdminScreen/assets/asset/') ? assetId : null;

	const returnTo = preloadAccountId
		? `/AdminScreen/accounts/account/${preloadAccountId}`
		: preloadAssetId
			? `/AdminScreen/assets/asset/${preloadAssetId}`
			: `/AdminScreen/contracts/contract/${id}`;

	const breadcrumb = preloadAccountId
		? [
			{ label: 'Inicio', to: '/AdminScreen' },
			{ label: t('entity.account.plural'), to: '/AdminScreen/accounts' },
			{ label: 'Cuenta', to: `/AdminScreen/accounts/account/${preloadAccountId}` },
			{ label: `Editar ${t('entity.contract')}` },
		]
		: preloadAssetId
			? [
				{ label: 'Inicio', to: '/AdminScreen' },
				{ label: t('entity.asset.plural'), to: '/AdminScreen/assets' },
				{ label: 'Activo', to: `/AdminScreen/assets/asset/${preloadAssetId}` },
				{ label: `Editar ${t('entity.contract')}` },
			]
			: [
				{ label: 'Inicio', to: '/AdminScreen' },
				{ label: t('entity.contract.plural'), to: '/AdminScreen/contracts' },
				{ label: `Editar ${t('entity.contract')}` },
			];

	return (
		<EntityList>
			<Helmet>
				<title>{`Editar ${t('entity.contract')}`}</title>
			</Helmet>
			<PageHead
				breadcrumb={breadcrumb}
				title={`Editar ${t('entity.contract')}`}
				subtitle={`Actualizá los datos del ${t('entity.contract').toLowerCase()}.`}
			/>
			<ContractEditor
				mode='edit'
				contractId={id}
				onCancel={() => navigate(returnTo)}
				onSaved={() => navigate(returnTo)}
				saveLabel='Guardar'
				preloadAccountId={preloadAccountId}
				preloadAssetId={preloadAssetId}
			/>
		</EntityList>
	);
}
export default EditContract;
